import { AlertTriangle, X } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import type { RigaSenzaPosto } from '../../lib/eventi/assegnazioni';

type Props = {
  righe: RigaSenzaPosto[];
  onSistema: (partecipanteId: string) => void;
  onNascondi: () => void;
};

/**
 * Dopo una proposta: chi aveva chiesto un'aula gia' piena e ha quel turno
 * vuoto. Da qui si apre la persona e le si sceglie un'altra aula.
 */
export function DaSistemare({ righe, onSistema, onNascondi }: Props) {
  return (
    <Card className="border-amber-300 bg-amber-50/40">
      <CardContent className="p-4 space-y-3">
        <div className="flex items-start justify-between gap-3">
          <div className="flex gap-2">
            <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="text-sm font-semibold text-gray-900">Da sistemare a mano ({righe.length})</h3>
              <p className="text-xs text-neutral-600 mt-0.5 leading-relaxed">
                {righe.length === 0
                  ? "Tutti hanno avuto quello che hanno chiesto: nessun turno e' rimasto vuoto."
                  : "Queste persone avevano chiesto un'aula gia' piena: il turno e' rimasto vuoto. Apri la persona e scegli un'altra aula."}
              </p>
            </div>
          </div>
          <Button variant="ghost" size="icon" onClick={onNascondi} aria-label="Nascondi" className="h-8 w-8 flex-shrink-0">
            <X className="w-4 h-4" />
          </Button>
        </div>
        {righe.length > 0 && (
          <ul className="divide-y divide-amber-200/60 rounded-lg border border-amber-200 bg-white">
            {righe.map((r) => (
              <li key={`${r.partecipanteId}-${r.giornoNome}-${r.turno}`} className="flex items-center gap-3 px-3 py-2">
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-gray-900 truncate">{r.nome}</p>
                  <p className="text-[11px] text-neutral-600 truncate">
                    {r.giornoNome}, turno {r.turno}: aveva chiesto {r.aula} · {r.titolo}
                  </p>
                </div>
                <Button variant="outline" size="sm" onClick={() => onSistema(r.partecipanteId)} className="flex-shrink-0">
                  Sistema
                </Button>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
